<div
    *ngIf="!showData"
    class="placeholder-text container-fluid d-flex align-items-center justify-content-center h-100"
>
    <p>{{ 'evaluation.SL.media.noDataMessage' | translate }}</p>
</div>
<div class="labeling-central-tile">
    <div class="current-image">
        <div class="current-image-inner">
            <app-image-canvas-viewport
                *ngIf="showData && selectedImage"
                [imageUrl]="selectedImage?.url"
                [imageWidth]="selectedImage?.width"
                [imageHeight]="selectedImage?.height"
                [boxes]="evaluationCanvasBoxes"
                [panEnabled]="true"
                [editable]="false"
                [selectable]="false"
                [maxLevel]="maxZoomLevel"
                [level]="currentZoomLevel"
                (levelChange)="onCanvasLevelChange($event)"
            ></app-image-canvas-viewport>
        </div>
    </div>
    <div class="zoom-and-paging-footer">
        <div
            class="paging-container d-flex justify-content-center"
            *ngIf="images.length"
        >
            <app-input-paging-bar
                tag="annotate"
                [maxValue]="totalElements"
                [currentValue]="currentImageNumber"
                (nextValue)="onNextValue($event)"
            ></app-input-paging-bar>
        </div>
        <div
            class="zoom-control-group"
            [ngClass]="{
                'zoom-out-disabled': currentZoomLevel === minZoomLevel,
                'zoom-in-disabled': currentZoomLevel === maxZoomLevel,
            }"
        >
            <div class="zoom-control" (click)="onZoomOut()" id="zoom-out">
                <p>-</p>
            </div>
            <input
                [formControl]="zoomControl"
                type="range"
                class="indicator"
                [min]="minZoomLevel"
                [max]="maxZoomLevel"
                (change)="onSliderZoomChange()"
            />
            <div class="zoom-control" (click)="onZoomIn()" id="zoom-in">
                <p>+</p>
            </div>
        </div>
    </div>
</div>
